/** 强制进入 SPA 互动版的 query 参数（Nginx / 分享页跳转用） */
export const APP_QUERY = 'app'

export function withAppQuery(path) {
  const base = String(path || '/').split('?')[0]
  return `${base}?${APP_QUERY}=1`
}

export function stripAppQuery(route) {
  if (!route.query || route.query[APP_QUERY] !== '1') {
    return null
  }
  const query = { ...route.query }
  delete query[APP_QUERY]
  return { path: route.path, query, hash: route.hash }
}
